<template>
  <div class="auth-login-account-activation-wrapper d-flex flex-column justify-center">
    <!-- EMAIL CONFIRMATION ALERT -->
    <auth-alert
      v-if="showConfirmEmailAlert"
      :alert-state="ALERT_STATES.SUCCESS_ALERT"
      class="auth-alert"
    >
      <template #title>
        <div>{{ $t('auth.login.confirmMessage') }}</div>
      </template>
      <template #buttons>
        <div
          class="auth-alert-cross-icon-container d-flex"
          @click="handleCloseAlert"
        >
          <icon name="cross24" class="auth-alert-cross-icon" />
        </div>
      </template>
    </auth-alert>
    <div class="auth-login-account-activation-title auth-text-style">
      {{ $t('auth.login.loginActivationTitle') }}
    </div>
    <div class="auth-login-account-activation-description auth-text-style">
      {{ $t('auth.login.loginActivationDescription') }}
    </div>
    <div class="auth-login-activation-line" />
    <!-- SEND EMAIL BUTTON -->
    <div
      tabindex="0"
      v-if="!counting && !manyAttemptsToSendEmail"
      class="auth-login-account-activation-send-button auth-text-style"
      @keydown.enter.prevent="sendConfirmRequest(true)"
      @click="sendConfirmRequest(true)"
    >
      {{ $t('auth.login.sendEmailAgain') }}
    </div>
    <!-- TIMER FOR SEND EMAIL -->
    <div
      v-if="counting && !manyAttemptsToSendEmail"
      class="auth-login-account-activation-timer auth-text-style"
    >
      {{ $t('auth.login.sendEmailAgainTimer') }} {{ formattedTime }}
    </div>
    <!-- MANY ATTEMPTS TEXT -->
    <div v-if="manyAttemptsToSendEmail" class="auth-login-activation-many-attempts auth-text-style">
      {{ $t('auth.login.sendEmailManyAttempts') }}
    </div>
    <!-- SUPPORT BUTTON -->
    <div
      tabindex="0"
      v-if="manyAttemptsToSendEmail"
      @click="handleWriteSupport"
      class="auth-login-account-activation-send-button auth-text-style"
    >
      {{ $t('auth.login.writeToSupport') }}
    </div>
  </div>
</template>
<script>
import AuthAlert from '@/components/auth/components/AuthAlert.vue'
import Icon from '@/assets/icons/Icon.vue'
import { ALERT_STATES } from '@/constants/alert'

export default {
  name: 'AuthLoginAccountActivation',
  components: { Icon, AuthAlert },

  data() {
    return {
      counting: false,
      time: 60,
      intervalId: null,
      manyAttemptsToSendEmail: false,
      showConfirmEmailAlert: false,
      count: parseInt(localStorage.getItem('requestEmailVerificationCount'), 10) || 0,
    }
  },

  computed: {
    ALERT_STATES() {
      return ALERT_STATES
    },

    formattedTime() {
      const minutes = Math.floor(this.time / 60)
      const seconds = this.time % 60
      return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
    }
  },

  mounted() {
    localStorage.setItem('requestEmailVerificationCount', 0)
  },

  beforeDestroy() {
    this.stopCountdown()
  },

  methods: {
    handleCloseAlert() {
      this.showConfirmEmailAlert = false
    },

    handleWriteSupport () {
      window.Intercom('show')
    },

    async sendConfirmRequest(isEmailSendedAgain) {
      const token = localStorage.getItem('confirmToken')

      try {
        const response = await this.apiV2.post('/email/verification-notification', { count: this.count }, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })

        if (response && response.status === 200 && isEmailSendedAgain) {
          this.startCountdown()
        }

        localStorage.setItem('requestEmailVerificationCount', this.count)
        this.count++
      } catch (err) {
        if (err && err.response && err.response.status === 429) {
          this.manyAttemptsToSendEmail = true
        } else {
          console.error('Error sending email verification request:', err.message)
        }
      }
    },

    startCountdown() {
      this.showConfirmEmailAlert = true
      this.counting = true
      this.intervalId = setInterval(() => {
        if (this.time > 0) {
          this.time--

          if (this.time < 50) {
            this.showConfirmEmailAlert = false
          }
        } else {
          this.stopCountdown()
        }
      }, 1000)
    },

    stopCountdown() {
      clearInterval(this.intervalId)
      this.showConfirmEmailAlert = false
      this.counting = false
      this.time = 60
    }
  }
}
</script>
<style lang="scss">
.auth-login-account-activation-wrapper {
  width: 400px;
  padding: 20px 24px;
  align-items: flex-start;
  gap: 12px;
  border-radius: 8px;
  background: var(--v-background-secondary-default-base);
}

.auth-text-style {
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  line-height: 24px;
}

.auth-login-account-activation-title {
  color: var(--v-text-primary-base);
  font-weight: 600;
}

.auth-login-account-activation-description {
  color: var(--v-text-secondary-base);
  font-weight: 400;
}

.auth-login-activation-line {
  height: 1px;
  width: 100%;
  border-radius: 2px;
  background: var(--v-border-secondary-base);
}

.auth-login-account-activation-send-button {
  cursor: pointer;
  color: var(--v-link-primary-text-default-base);
  border-bottom: 1px solid var(--v-link-primary-border-default-base);
  font-weight: 400;
  width: fit-content;
}

.auth-login-account-activation-timer {
  color: var(--v-text-secondary-base);
  font-weight: 600;
}

.auth-login-activation-many-attempts {
  color: var(--v-text-error-base);
  font-weight: 400;
}

.auth-alert {
  position: absolute;
  top: 6%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 745px;
}

.auth-alert-cross-icon-container {
  cursor: pointer;
}

.auth-alert-cross-icon {
  color: var(--v-alert-success-foreground-base);
}
</style>
